import { render, staticRenderFns } from "./user_level.vue?vue&type=template&id=70c3b668&"
import script from "./user_level.vue?vue&type=script&lang=js&"
export * from "./user_level.vue?vue&type=script&lang=js&"
import style0 from "./user_level.vue?vue&type=style&index=0&id=70c3b668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports